import { Box, Center, Loader } from "@mantine/core";
import React, { useEffect, useRef, useState } from "react";

import { PHONE_SCREEN, PreviewDeviceFrame } from "./PreviewDeviceFrame";
import { useTranslation } from "react-i18next";

// Unframed only: the page's own `.trm-device-container` height, not its background
// art - that svg is 612 tall for both, but the halfpage ad runs to 660 and cutting
// it at 612 clips the bottom of the ad.
const SCREEN_WIDTH = 300;
const SCREEN_HEIGHTS = {
  medium_rectangle: 550,
  halfpage: 660,
};
const FALLBACK_HEIGHT = SCREEN_HEIGHTS.halfpage;

/**
 * @param {{ singleAdQuery: any, format?: string, withFrame?: boolean }} props
 */
function IntegrationPreviewTmp({ singleAdQuery, format, withFrame = true }) {
    const { t } = useTranslation();

  const src = singleAdQuery?.data?.ad_preview_integration;
  const height = withFrame ? PHONE_SCREEN.height : SCREEN_HEIGHTS[format] ?? FALLBACK_HEIGHT;

  const mountStamp = useRef(new Date().getTime()).current;
  const [reloadNonce, setReloadNonce] = useState(0);
  const wasRefetching = useRef(false);

  useEffect(() => {
    const isRefetching = Boolean(singleAdQuery?.isRefetching);
    if (wasRefetching.current && !isRefetching) {
      setReloadNonce((nonce) => nonce + 1);
    }
    wasRefetching.current = isRefetching;
  }, [singleAdQuery?.isRefetching]);

  if (!src) return null;

  const screenBox = (
    <Box miw={SCREEN_WIDTH} w={SCREEN_WIDTH} mih={height} p={0}>
      {singleAdQuery?.isRefetching ? (
        <Center h={height}>
          <Loader color="gray" />
        </Center>
      ) : (
        <iframe
          scrolling="no"
          src={`${src}${src.includes("?") ? "&" : "?"}cacheId=${mountStamp}-${reloadNonce}`}
          width={SCREEN_WIDTH}
          height={height}
          frameBorder="0"
          title={t('adBuilder.integrationPreview')}
          style={{ border: 0, display: "block" }}
        />
      )}
    </Box>
  );

  if (!withFrame) return screenBox;

  return <PreviewDeviceFrame>{screenBox}</PreviewDeviceFrame>;
}

export const IntegrationPreview = React.memo(IntegrationPreviewTmp);
